import { ContentType, QueryKey } from '../consts/index.mjs';

const revoke = async (revocationEndpoint, clientId, token, requester) => requester(revocationEndpoint, {
    method: 'POST',
    headers: ContentType.formUrlEncoded,
    body: new URLSearchParams({
        [QueryKey.ClientId]: clientId,
        [QueryKey.Token]: token,
    }),
});

export { revoke };
